import { curry } from 'rambda';

export const isNode = (node) => node && node.data;
const toLowerCase = (str = '') => str && str.toLowerCase();
export const findInNodeData = curry((where, prop, node, compareTo) => {
  return (
    node.data &&
    node.data[where] &&
    node.data[where].find(
      (member) => toLowerCase(member[prop]) === toLowerCase(compareTo),
    )
  );
});

export const findInMessagesByUrlFormat = findInNodeData(
  'messages',
  'urlFormat',
);

export const findInEventsByUrlFormat = findInNodeData('events', 'urlFormat');

export const findInCallbacksByUrlFormat = findInNodeData(
  'callbacks',
  'urlFormat',
);

export const findInRelatedGuidesByUrlFormat = findInNodeData(
  'relatedGuides',
  'urlFormat',
);

export const findInPropertiesByUrlFormat = findInNodeData(
  'properties',
  'urlFormat',
);

export const findInOperationsByUrlFormat = findInNodeData(
  'operations',
  'urlFormat',
);

export const findInClientEventsByUrlFormat = findInNodeData(
  'clientEvents',
  'urlFormat',
);

export const findInMessagesByTopic = findInNodeData('messages', 'topic');
export const findInMessagesByName = findInNodeData('messages', 'name');
export const findInCallbacksByName = findInNodeData('callbacks', 'name');
export const findInRelatedGuidesByName = findInNodeData(
  'relatedGuides',
  'name',
);

export const findInEventsByTopic = findInNodeData('events', 'topic');
export const findInEventsByName = findInNodeData('events', 'name');
export const findInPropertiesByName = findInNodeData('properties', 'name');

export const hasProperty = curry((node, prop) => node.data && node.data[prop]);

export const getName = (obj) => (obj && (obj.displayName || obj.name)) || '';
export const getArtifactId = (data) => data.extra && data.extra.artifactId;
